module.exports = __webpack_public_path__ + "img/blank.60a405aa.svg";